import {Enum} from 'enumify';

export default class CustomerType extends Enum {}

CustomerType.initEnum({
  NEW_CUSTOMER: {
    title: 'New customer',
  },
  EXISTING_CUSTOMER: {
    title: 'Existing customer',
  },
});



// WEBPACK FOOTER //
// ./src/routes/payment/CustomerType.js